import { ManagerInvitationResponseType, ManagerInvitationAPIFormType } from './../../types/managerInvitation';
import { axiosInstance } from './index';

export const managerInvitationService = {
    async managerInvitationAndCount(param: ManagerInvitationAPIFormType) {
        const { data } = await axiosInstance.post(`User/ManagerJoinByInvitation`, param);
        return data as ManagerInvitationResponseType;
    },
};
